import React, { useCallback, useState } from "react";
import { Container, Row } from "reactstrap";
import IcoIconBody from "./IcoIconBody";
import IconMarkUp from "../Common/IconMarkUp";
import { icoIconData } from "../../../Data/Icons/IcoIcon";
import { Breadcrumbs } from "../../../AbstractElements";
import { IcoIconTitle, Icons } from "../../../Constants/Constants";

const IcoIconContainer = () => {
  const [iconTag, setIconTag] = useState({ iconTag: "" });
  const [icon, setIcon] = useState({ icon: "" });
  const [iconFClass, setIconFClass] = useState({ iconFClass: "" });
  const callback = useCallback((tag: string) => {
    setIconTag({
      iconTag: '<i className="icofont icofont-' + tag + '"></i>',
    });
    setIcon({
      icon: "icofont icofont-" + tag + " fa-2x",
    });
    setIconFClass({
      iconFClass: "icofont icofont-" + tag,
    });
  }, []);
  return (
    <>
      <Breadcrumbs mainTitle={IcoIconTitle} parent={Icons} />
      <Container fluid>
        <Row>
          {icoIconData.map((data, i) => (
            <IcoIconBody key={i} iconType={data.icons} title={data.title} parentCallback={callback} />
          ))}
        </Row>
      </Container>
      <IconMarkUp iconTag={iconTag} icon={icon} iconFClass={iconFClass} />
    </>
  );
};
export default IcoIconContainer;
